var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',{attrs:{"title":"Acesso com Certificado Digital (e-CPF)","titleIcon":"fas fa-id-card"}},[_c('ecpf',{on:{"autenticado":_vm.concluido}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }